document.addEventListener('DOMContentLoaded', function () {
    window.videoBgSize()

    window.addEventListener('resize', window.videoBgSize, false);

    const counters = document.querySelectorAll('.welcome .icons .number span')

    for (let countersIndex = 0; countersIndex < counters.length; countersIndex++) {
        counters[countersIndex].setAttribute('style', 'display:inline-block;min-width:' + counters[countersIndex].offsetWidth.toString() + 'px;')

        new countUp.CountUp(
            counters[countersIndex].getAttribute('id'),
            parseInt(counters[countersIndex].innerText),
            {
                enableScrollSpy: true
            }
        );
    }

    const moveNextButton = document.getElementById('move-next')

    if (moveNextButton) {
        moveNextButton.addEventListener('click', function () {
            const y = document.getElementById('about-company')
                .getBoundingClientRect().top + window.scrollY;

            window.scroll({
                top: y - 60,
                behavior: 'smooth'
            });
        })
    }

    const reviewsSlider = document.getElementById('reviews-swiper')

    if (reviewsSlider) {
        new Swiper(reviewsSlider, {
            direction: 'horizontal',
            autoHeight: true,
            spaceBetween: 20,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }

    const blogSlider = document.getElementById('blog-swiper')

    if (blogSlider) {
        new Swiper(blogSlider, {
            direction: 'horizontal',
            autoHeight: true,
            spaceBetween: 20,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                1400: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 2
                },
                320: {
                    slidesPerView: 1
                }
            }
        });
    }
})

if (!window.videoBgSize) {
    window.videoBgSize = function () {
        const videoBg = document.getElementById('video-bg')

        if (videoBg) {
            const blockWidth = videoBg.closest('.welcome').getBoundingClientRect().width,
                blockHeight = videoBg.closest('.welcome').getBoundingClientRect().height

            videoBg.setAttribute('style', 'width:' + blockWidth.toString() + 'px;height:' + blockHeight.toString() + 'px;object-fit:cover;')
        }
    }
}
